<template>
    <div class="banner-swiper">
        <!-- 轮播图 -->
        <div class="swiper">
            <swiper
                :modules="modules"
                :pagination="{
                    clickable: true
                }"
                :autoplay="{ delay: 3500, disableOnInteraction: false }"
                :loop="true"
                :navigation="navigation"
                :slides-per-view="1"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
            >
                <!-- 循环背景图 -->
                <swiper-slide v-for="(item, index) in bannerList" :key="index">
                    <div
                        class="back-image"
                        @click="bannerClickHandler(item.link)"
                        :style="{
                            background:
                                'url(' +
                                item.image +
                                ') no-repeat center center',
                            backgroundSize: 'cover'
                        }"
                    ></div>
                </swiper-slide>

                <!-- 分页小滑条 -->
                <div
                    class="swiper-pagination swiper-pagination-white"
                    slot="pagination"
                ></div>
            </swiper>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, Navigation, Scrollbar } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination' // 轮播图底面的小圆点
import 'swiper/css/navigation' // 轮播图两边的左右箭头
import 'swiper/swiper-bundle.css'
import 'swiper/css/scrollbar' // 轮播图的滚动条
import 'swiper/swiper-bundle.min.css'
import useAppStore from '@/stores/modules/app'
const appStore = useAppStore()

const bannerList = computed(() => {
    let banner = appStore.icpParamsConig?.system?.banner || ''
    banner = banner
        ? JSON.parse(banner)
        : [
              'https://icp.yuntuoit.com/uploads/images/20241220/20241220162451dd8090985.png'
          ]
    return banner
})

const router = useRouter()

const modules = [Autoplay, Pagination, Navigation, Scrollbar]

// 轮播左右切换按钮
const navigation = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
}
const onSwiper = (swiper: any) => {
    // console.log(swiper)
}
const onSlideChange = () => {
    // console.log('slide change')
}
const bannerClickHandler = (link: string) => {
    const path = String(link).trim()
    if (!path) return
    const isHttp = path.includes('http')
    if (isHttp) {
        window.open(path)
    } else {
        router.push({
            path
        })
    }
}
</script>

<style lang="scss" scoped>
.back-image {
    background-size: cover;
    width: 100%;
    height: 615px;
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev {
    color: #f5f5f5;
    opacity: 0.5;
    right: 50px;
    width: 60px;
    height: 60px;
    border: 1px solid #f5f5f5;
    line-height: 60px;
    text-align: center;
    border-radius: 50%;
    padding: 5px;
}

.swiper-button-prev:hover {
    color: #fff;
    opacity: 0.9;
    border: 1px solid #fff;
}
.swiper-button-prev,
.swiper-rtl .swiper-button-next {
    color: #f5f5f5;
    opacity: 0.5;
    left: 50px;
    width: 60px;
    height: 60px;
    border: 1px solid #f5f5f5;
    line-height: 60px;
    text-align: center;
    border-radius: 50%;
    padding: 5px;
}

.swiper-button-next:hover {
    color: #fff;
    opacity: 0.9;
    border: 1px solid #fff;
}

::v-deep .swiper-pagination-bullet-active {
    width: 33px;
    height: 3px;
    background: #fff !important;
    border-radius: 2px !important;
}
::v-deep .swiper-pagination-bullet {
    width: 33px;
    height: 3px;
    border-radius: 0px !important;
    z-index: 99999 !important;
}
:deep(.swiper-pagination) {
    text-align: left !important;
    max-width: 1200px;
    left: 50%;
    bottom: 70px !important;
    transform: translate(-50%, -50%);
}
@media (max-width: 1260px) {
    :deep(.swiper-pagination) {
        padding: 0 30px;
    }
}
</style>
